import React, { useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const AvanseLendingPartner = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Landing Partner"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Landing Partner"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const uniqueFeatures = [
        {
            title: "1. What is the highest loan amount available through the Avanse education loan?",
            content: "You can avail a loan of up to INR 50 Lakh without the need for collateral. If you can provide collateral, the loan amount can go up to INR 80 Lakh. The final loan amount is subject to various factors such as the course fee, the country of study, and the income of the co-applicant."
        },
        {
            title: "2. What is the interest rate on an education loan from Avanse?",
            content: "In the United States, the typical tuition rates span from 10.75% to 12.0% – 13.0%, whereas for colleges and universities in other countries, the range lies between 10.75% – 12.0% – 12.0% – 13.0%, depending on the institution."
        },
        {
            title: "3. What is the time frame for repaying the Avanse education loan?",
            content: "Avanse education loans can be repaid over 15 years."
        },
        {
            title: "4. Where is the loan disbursed - the borrower's account or the institution's account?",
            content: "Other living expenditures are moved to the borrower’s account, while tuition and on-campus housing fees are credited to the university’s account."
        }, {
            title: "5. Is it possible to get an education loan from Avanse without providing collateral?",
            content: "Avanse provides education loans up to INR 75 Lakh without requiring collateral."
        },
        {
            title: "6. Are there any charges for prepaying Avanse education loans?",
            content: "No, after six months of disbursement, there is no penalty for early payment."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const handleAccordion = idx => {
        setOpenIndex(openIndex === idx ? null : idx);
    };
    return (
        <>
            <BannerBreadcrumb head={"Avanse Education Loan"} parades={"Get Free Education Loan Assistance From Credere"} pagename={"Avanse Education Loan"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">Avanse Education Loan for Abroad Studies</h5>
                            <p className="loan-elegibility-des">For students who want to continue their study abroad or in India, Avanse Financial Services, a Non-banking Financial Company (NBFC), offers education loans. The company strives to make the loan application procedure as simple and stress-free as possible and offers tailored loan solutions for a variety of courses and universities.
                                <br /><br />
                                Avanse Financial Services offers education loans for studying abroad that include over 2000 universities and colleges, as well as 27,000 pre-approved courses in more than 50 countries. To help applicants advance their careers overseas while studying, they provide a range of financial services such as pre-visa disbursement loans, pre-admission loans, bridge loans, fast-track loans, and score-based advantages.</p>
                            <h5 className="about-head">Overview of the Avanse Abroad Education Loan</h5>

                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Description	</th>


                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Rate of interest</td>
                                        <td className="">

                                            10.75% - 13.0%

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">

                                            Up to INR 75 Lakh

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Moratorium period</td>
                                        <td className="">

                                            Course duration + 1-year

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Repayment tenure</td>

                                        <td className="">15 years</td>

                                    </tr>
                                    <tr>
                                        <td className="">
                                            Processing fees</td>
                                        <td className="">

                                            1-1.5%

                                        </td>


                                    </tr>

                                    <tr>
                                        <td>
                                            Processing time</td>
                                        <td>7-10 days</td></tr>
                                    <tr>
                                        <td>Margin money</td>
                                        <td>Nil</td>
                                    </tr>
                                </tbody>
                            </table>

                            <p className="loan-elegibility-des">The moratorium period refers to a specific timeframe where you are not obligated to repay your education loan.
                                <br /><br />
                                The borrower’s contribution towards a loan is known as margin money, with the lender covering the rest of the amount.
                                <br /><br />
                                For students planning to study abroad, Avanse Financial Services provides both secured and unsecured loans. The customer-centric strategy of Avanse is one of its distinctive traits. If you are applying for a Bachelor’s course, kindly remember that the collateral is required.
                                <br /><br />
                                To Qualify for an Avanse Education Loan, Certain Conditions Must be Met</p>
                            <h5 className="about-head mb-4">Age</h5>
                            <p className="loan-elegibility-des">At the time of application, the applicant needs to be at least 18 years old or above. Moreover, the student should have obtained admission to a recognized university.</p>


                            <h5 className="about-head">Academic Performance</h5>
                            <p className="loan-elegibility-des">The applicant has to meet the minimal academic standards set by the lending institution and have a good academic background. Moreover, the student needs to sit for necessary exams like GRE, IELTS, or TOEFL. GRE is essential for obtaining an education loan in the United States.</p>
                            <h5 className="about-head">Co-applicant</h5>
                            <p className="loan-elegibility-des">A co-applicant with a regular source of income and a good credit history is required for the loan application. This co-applicant may be the applicant’s mother, father, sister, brother, spouse, paternal or maternal relative, or legal guardian.</p>
                            <h5 className="about-head">Course and Country of Study</h5>
                            <p className="loan-elegibility-des">The scheme will cover regular graduate Degree, post-graduate Degree, Diploma, Certificate, and doctorate courses in any discipline offered by foreign Institutes/Universities in various countries such as the USA, UK, Canada, Australia, New Zealand, France, Germany, and Ireland.</p>

                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="col-md-12 loan-eligibility">





                            <h5 className="about-head">Avanse Education Loan for the US</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>GRE &gt;=310	</th>
                                        <th>GRE 300 - &lt; 310</th>
                                        <th>GRE 285 - &lt; 299</th>

                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Avanse eduaction loan interest rate</td>
                                        <td className="">

                                            12.25 - 12.75%

                                        </td>
                                        <td className="">12.75 - 13%</td>
                                        <td>13 - 14%</td>

                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">

                                            Up to INR 50 Lakh

                                        </td>
                                        <td className="">Up to INR 40 Lakh</td>
                                        <td>Up to INR 35 Lakh</td>

                                    </tr>
                                    <tr>
                                        <td className="">
                                            Co-applicant minimum income</td>
                                        <td className="">

                                            INR 30K

                                        </td>
                                        <td className="">INR 35K</td>
                                        <td>INR 35K</td>

                                    </tr>
                                    <tr>
                                        <td className="">
                                            Monthly installment during the course</td>

                                        <td className="">Partial simple interest</td>
                                        <td>Partial simple interest</td>
                                        <td>Simple interest</td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Processing fees</td>
                                        <td className="">

                                            1%

                                        </td>

                                        <td>1%</td>
                                        <td className="">1%</td>

                                    </tr>

                                </tbody>
                            </table>
                            <h5 className="about-head">Avanse Education Loan for Other Countries</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Australia / New Zealand</th>
                                        <th>Canada</th>
                                        <th>UK</th>
                                        <th>Germany/Ireland/France/Italy</th>
                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Avanse eduaction loan interest rate</td>
                                        <td className="">

                                            12.5 - 12.75%

                                        </td>
                                        <td className="">12.5 - 13%</td>
                                        <td>12.5 - 13.5%</td>
                                        <td>12.5 - 13.5%</td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">

                                            INR 20 Lakh

                                        </td>
                                        <td className="">INR 30 Lakh</td>
                                        <td>INR 40 Lakh</td>
                                        <td>INR 20 Lakh</td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Co-applicant minimum income</td>
                                        <td className="">

                                            INR 60K

                                        </td>
                                        <td className="">INR 30K</td>
                                        <td>INR 40K</td>
                                        <td>INR 40K</td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Monthly installment during the course</td>
                                        <td className="">

                                            EMI

                                        </td>
                                        <td className="">Simple interest</td>
                                        <td>Simple interest</td>
                                        <td>Simple interest</td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Processing fees</td>
                                        <td className="">

                                            1 - 1.5%

                                        </td>
                                        <td className="">1%</td>
                                        <td>1 - 2%</td>
                                        <td>1 - 1.5%</td>
                                    </tr>

                                </tbody>
                            </table>
                            <p className="loan-elegibility-des">Avanse Financial Services requires borrowers to pay a compulsory premium for credit life insurance, which typically ranges from 1.25% to 1.5% of the total loan amount.

                                Avanse includes an optional health insurance premium of about INR 40K for international health coverage.</p>


                            <h5 className="about-head">To Apply for An Education Loan from Avanse, Certain Documents Are Required</h5>
                            <p className="loan-elegibility-des">Credere provides an individualized list of required documents for education loans, based on your profile and the profile of your co-applicant.</p>
                            <h6 className="subhead">Applicant's Documents</h6>
                            <ol className="subhead-ul">
                                <li>Education loan application form</li>
                                <li>Identity proof: Passport/ PAN/ Driver’s License/ Voter ID card or government-issued identification document.</li>
                                <li>Address proof: recent copy of telephone bill/ electricity bill/water bill/ piped gas bill/ driving license/ Aadhaar card.
                                    Passport</li>
                                <li>Past academic record</li>
                                <li>10th standard mark sheet</li>
                                <li>12th standard mark sheet</li>
                                <li>Undergraduate result (semester-wise)</li>
                                <li>Proof of admission: admission letter (A conditional admission letter is also applicable). Entrance exam results (e.g. GMAT, GRE, TOEFL, etc.)</li>
                                <li>Statement of expenses</li>
                                <li>Loan A/C statement of one year (if applicable).</li>
                                <li>Bank account statement of the student (if applicable).</li>
                                <li>2 passport-size photographs.</li>
                            </ol>
                            <h6 className="subhead">Co-applicant's Documents</h6>
                            <ol className="subhead-ul">
                                <li>Address: recent copy of telephone bill/ water bill/ electricity bill/piped gas bill or copy of passport/ Aadhaar card/driving license</li>
                                <li>Identity proof: PAN/ Driver’s license/ Passport/ Voter ID card or government-issued identification document.</li>
                                <li>Legal documents of the collateral/ property documents.</li>
                                <li>If any previous loan is from other banks/ lenders, then the loan A/C statement of 1 year.</li>
                                <li>2 passport-size photographs.</li>
                                <li>Bank account statement of the co-borrower/guarantor, for the last 6 months (in case of takeover of education loan).</li>
                            </ol>
                            <h6 className="subhead">Income Proof for Salaried Co-applicant/Guarantor</h6>
                            <ol className="subhead-ul">
                                <li>Copy of Form 16 of the last 2 years or a copy</li>
                                <li>Salary slips for the last 3 months</li>
                                <li>Brief statement of assets & liabilities of parent/ guardian/ other co-borrower</li>
                                <li>Bank account statement for the last 6 months (Salary account)</li>
                            </ol>
                            <h6 className="subhead">Income Proof for Self-employed Co-applicant/ Guarantor</h6>
                            <ol className="subhead-ul">
                                <li>Business address proof</li>
                                <li>Last 2 years IT returns (If IT Payee)</li>
                                <li>TDS certificate (Form 16A, if applicable)</li>
                                <li>Certificate of qualification (for C.A./ doctor and other professionals)</li>
                                <li>Brief statement of assets & liabilities of parent/ guardian/ other co-borrower</li>
                                <li>Bank account statement for the last 6 months</li>
                            </ol>
                            <h6 className="subhead">Verification of income for Self-employed Co-applicant/Guarantor</h6>
                            <ol className="subhead-ul">
                                <li>Business address proof</li>
                                <li>TDS certificate (Form 16A, if applicable)</li>
                                <li>Last 2 years IT returns (If IT Payee)</li>
                                <li>Brief statement of assets & liabilities of parent/ guardian/ other co-borrower</li>
                                <li>Certificate of qualification (for C.A./ doctor and other professionals)</li>
                                <li>Bank account statement for the last 6 months</li>
                            </ol>

                            <h5 className="about-head mb-4">What is the Procedure for Reaching out to Avanse Regarding an Education Loan?</h5>
                            <p className="loan-elegibility-des">If you have any inquiries related to studying abroad, you can reach out to Avanse using the following contact methods.</p>
                            <p className="loan-elegibility-des"><b>Email</b></p>

                            <p className="loan-elegibility-des">If you need to get in touch with Avanse, email is the way to go. By sending an email to wecare@avanse.com, you can reach their dedicated customer support team. Make sure to offer all the related information about your profile in the email, as this will allow them to offer you a response that is personalized to your requirements.</p>

                            <p className="loan-elegibility-des"><b>Online Application Form</b></p>

                            <p className="loan-elegibility-des">To initiate the application process, you have the option to fill out an online application form available on the official Avanse website www.avanse.com. By accessing this platform, you can conveniently provide the required information and submit your application electronically.</p>

                            <p className="loan-elegibility-des"><b>Branch Visits </b></p>

                            <p className="loan-elegibility-des"> To ensure a more personalized experience, you may go to visit the nearest Avanse branch in your city or locality. Avanse’s main office is located in Mumbai, and they also have branch offices in several cities throughout India, such as Delhi, Ahmedabad, Bangalore, Hyderabad, Chennai, and Chandigarh.
                                <br /><br />
                                You may apply for an education loan through Credere, an education financing platform that specializes in helping students secure funds for their higher education abroad if you prefer an easier approach and want to avoid the stress of physically visiting branches and dealing with intricate application forms. Our committed counselors will thoroughly review your profile and suggest the best lenders based on your specific loan preferences. Our knowledgeable counselors will offer continuous assistance during the loan procedure and will be ready to handle any challenges or issues that may come up.</p>
                            <h5 className="about-head">Advantages of Using Credere to Obtain your Avanse Student Loan</h5>
                            <p className="loan-elegibility-des"><b>Assured Best Loan Option</b></p>

                            <p className="loan-elegibility-des">  Credere is dedicated to offering you the finest education loan available in the market. We strive to obtain the optimal deal for your benefit.</p>

                            <p className="loan-elegibility-des"><b>Quick Processing Time</b></p>

                            <p className="loan-elegibility-des">  Credere representatives collaborate with different departments at Avanse Finance to streamline the process and expedite loan approval within a timeframe of 5-7 days. This is the reason that each year thousands of students contact us with their loan applications. The typical loan processing period for students who apply directly to the NBFC is between 10 and 12 days.</p>
                            <p className="loan-elegibility-des"><b>Completely Free Services Offered</b></p>

                            <p className="loan-elegibility-des"> At Credere, we provide our services to applicants without any cost. There are no processing fees or commissions that applicants need to pay.</p>

                            <p className="loan-elegibility-des"><b>Higher Chances of Approval</b></p>

                            <p className="loan-elegibility-des">   If any obstacles arise regarding the documentation or the application process, Credere will take the necessary steps to assist and work towards resolving the issue by collaborating with the officials at Avanse. </p>
                            <p className="loan-elegibility-des"><b>Effortless Process</b></p>

                            <p className="loan-elegibility-des">Numerous challenges may arise when directly applying for an Avanse education loan. Credere offers a simpler alternative. By visiting Credere’s website, you can easily assess your eligibility for the loan. Once confirmed, you can rest assured knowing that a dedicated education loan counselor will be assigned to assist you throughout the process. </p>
                            <h5 className="about-head">Procedure for Requesting an Avanse Education Loan with Credere Finance</h5>
                            <p className="loan-elegibility-des">To secure an education loan from Avanse, you have the option to conveniently apply online via their official website. Nevertheless, if you prefer a smoother and quicker application procedure, Credere offers an alternative platform for you to apply for your education loan.

                                Credere serves as a digital platform specifically crafted to aid Indian students in funding their overseas education. With a streamlined process, this platform can facilitate the approval of your education loan in a mere four simple steps.</p>
                            <h5 className="about-head mt-4"> FAQ (Frequently Asked Questions) </h5>


                            {uniqueFeatures.map((item, idx) => (
                                <div className={`accordion-item${openIndex === idx ? ' open' : ''}`} key={idx}>
                                    <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                        {item.title}
                                        <span className="accordion-arrow">{openIndex === idx ? '-' : '+'}</span>
                                    </button>
                                    <div className="accordion-content" style={{ maxHeight: openIndex === idx ? '500px' : '0' }}>
                                        <p className="loan-eligibility-des mb-0">{item.content}</p>
                                        <p className="loan-eligibility-des mt-3"><b>{item.head}</b>{item.content1}</p>
                                        <p className="loan-eligibility-des"><b>{item.head1}</b>{item.content2}</p>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div >
                </div>
            </section >
        </>
    )
}

export default AvanseLendingPartner;